<div>
    <div class="flex flex-horiz-space-bw">
        <h4>Enter your Notes <span style='color: red;'>*</span></h4>
    </div>
    <angular-editor [(ngModel)]="note" id="'followup'" [config]="editorConfig"
        (ngModelChange)="editorMaxLength($event)"></angular-editor>
    <p style="font-size: xx-small;">{{note? note.length: 0}}/{{'2000}}</p>

    <div class="grid grid-2x m-t-20" style="padding-top: 10px;">
        <div>
            <div>
                <h4>Collaboration Party</h4>
            </div>
            <nz-select  *ngIf="collaborationPartyList?.length > 0; else noCollabParty" nzShowSearch id="collaborationPartyCd" [(ngModel)]="collaborationPartyCd"
                (ngModelChange)="onCollabPartyChange($event)" style="width: 90%">
                <nz-option *ngFor="let item of collaborationPartyList" [nzLabel]="item.lookupValue"
                    [nzValue]="item.lookupKey"></nz-option>
            </nz-select>
        </div>
        <ng-template #noCollabParty>
            <div>
                <input type="text" class="ant-input" style="width: 96%; color: #0b0b0b;"
                    [value]="'No party configured'" readonly />
            </div>
        </ng-template>
    </div>
    <div *ngIf="collaborationPartyCd" class="m-t-15">
        <div class="grid grid-2x grid-gap-20">
            <div class="heading-tab">
                <h3 class="heading" style="font-weight:400;"><i nz-icon [nzType]="'file-text'"></i> Chasers</h3>
            </div>
            <div class="text-a-right">
                <button nz-button nzType="primary" (click)="newChaser()"><i nz-icon nzType="plus" nzTheme="outline"></i>
                    Add Chaser</button>
            </div>
        </div>
        <div *ngIf="refreshTable">
            <app-generic-zero-ui *ngIf="!commonUtilty.isArrayIterable(totalChasersList) && totalChasersList.length <=0"
                [list]="totalChasersList" title="Chasers" message="No data found"></app-generic-zero-ui>
            <nz-table *ngIf="commonUtilty.isArrayIterable(totalChasersList) && totalChasersList.length > 0"
                [nzSize]="'small'" #chaserTableData [nzData]="totalChasersList">
                <thead>
                    <tr>
                        <th scope="col">{{'Chaser Number' | MMSTranslate}}</th>
                        <th scope="col">{{'No of days' | MMSTranslate}}</th>
                        <th scope="col">{{'Chaser Type' | MMSTranslate}}</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let data of totalChasersList;index as i">
                        <td>
                            <nz-input-number [(ngModel)]="data.chaserNum" [nzMin]="0" [nzMax]="100"
                                [nzStep]="1"></nz-input-number>
                        </td>
                        <td>
                            <nz-input-number [(ngModel)]="data.chaserDays" [nzMin]="0" [nzMax]="100"
                                [nzStep]="1"></nz-input-number>
                        </td>
                        <td>
                            <nz-select nzShowSearch id="totalChasers" [(ngModel)]="data.typeCd" style="width: 90%">
                                <nz-option
                                    *ngFor="let item of (lookup$['followupActions'] | async) ; trackBy:item?.lookupKey"
                                    [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                            </nz-select>
                        </td>
                        <td>
                            <a style="color: red;" (click)="removeChaser(i)"><span nz-icon nzType="delete"
                                    nzTheme="outline"></span></a>
                        </td>
                    </tr>
                </tbody>
            </nz-table>
        </div>
    </div>
<div>
    <app-document-manager [mode]="'mini'" [requirementCd]="'ADDITIONAL_DOCUMENTS'"
        [clientRefGuid]="newCollaborationGuid" [heading]="'Documents'" [clientDO]="_IO.clientDOs" [requirements]="[]"
        [inputDataForEdit]="[]" [RequirementEntityGuid]="transactionGuid">
    </app-document-manager>
</div>

</div>
<div class="modal-footer-buttons">
    <button nz-button (click)="cancelTask()">Close</button>
    <button nz-button nzType="primary" (click)="refertoUserDummy()" [disabled]="!collaborationPartyList || collaborationPartyList.length === 0">Confirm</button>
</div>